import { SVGProps } from 'react';

const Blend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 22a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
    />
  </svg>
);
export default Blend;
